import React, { useContext, useEffect, useMemo, useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Stack,
  Tabs,
  Tab,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  Apps as AppsIcon,
  WarningAmber as WarningIcon,
  LocalGasStation as GasIcon,
  BarChart as BarChartIcon,
} from "@mui/icons-material";
import AuthContext from "../../Context/Auth/AuthContext";
import Tooltip from "@mui/material/Tooltip";
import GridCard from "../ArchivosCards/GridCards/Grid";
import clienteAxios from "../../config/axios";
import Cargando from "../components/Cargando/Cargando";
import GraficoLineaHis from "./GraficoLineaHis";
import GraficoLineaReserva from "./GraficoLineaReserva";
// import Reservas from "../Veterinaria/Reservas/Reservas";
import Chart from "./Chart";
import GraficoDougProductos from "./GraficoDougProductos";
import { Liquid } from "./Liquid";
import DispensadoresScreen from "./DispensadoresScreen";
import ReconnectingWebSocket from "reconnecting-websocket";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

const SectionTitle = ({ icono, titulo, subtitulo, right }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      marginBottom: "0.75rem",
      marginTop: "0.25rem",
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={{
          width: 6,
          height: 28,
          borderRadius: 1,
          backgroundColor: "primary.main",
          flexShrink: 0,
        }}
      />
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.1 }}>
          {icono} {titulo}
        </Typography>
        {subtitulo && (
          <Typography variant="caption" color="text.secondary">
            {subtitulo}
          </Typography>
        )}
      </Box>
    </Box>
    {right}
  </Box>
);

const PanelCard = ({ children, sx }) => (
  <Card
    elevation={2}
    sx={{
      borderRadius: 3,
      border: "1px solid",
      borderColor: "divider",
      overflow: "hidden",
      ...sx,
    }}
  >
    <CardContent sx={{ padding: "1.25rem" }}>{children}</CardContent>
  </Card>
);

const Dashboard = () => {
  // eslint-disable-next-line
  const { usuario } = useContext(AuthContext);
  // eslint-disable-next-line
  const vet = useMemo(() => usuario.empCategoria === "VETERINARIA", []);
  const [seccionActive, setseccionActive] = useState({
    cardsSeccion: false,
    info: true,
    estadisticas: false,
  });
  const { cardsSeccion, info, estadisticas } = seccionActive;
  // const [tanquesData, setTanquesData] = useState([]);
  // const getTanquesData = async () => {
  //   const res = await clienteAxios.get("/tanques/todo");
  //   console.log({ res });
  //   setTanquesData(res.data);
  // };
  const [tanquesData, setTanquesData] = useState([]);

  useEffect(() => {
    const ws = new ReconnectingWebSocket(
      "wss://pts2-gas-ultra.neitor.com/ws/inventario_actual",
    );

    ws.onopen = () => {
      console.log("WebSocket conectado");
    };

    ws.onmessage = (event) => {
      console.log({ event });

      try {
        const message = JSON.parse(event.data);

        if (message.type !== "inventory_update") return;

        if (
          message.codEmp &&
          usuario.rucempresa &&
          message.codEmp !== usuario.rucempresa
        ) {
          return;
        }

        if (!Array.isArray(message.data)) return;

        setTanquesData(message.data);
      } catch (error) {
        console.error("Error al procesar el mensaje del WebSocket:", error);
      }
    };

    ws.onerror = (error) => {
      console.error("Error en el WebSocket:", error);
    };

    ws.onclose = () => {
      console.log("WebSocket desconectado");
    };

    return () => {
      ws.close();
    };
  }, [usuario.rucempresa]);

  // useEffect(() => {
  //   getTanquesData();
  // }, []);

  const classes = useStyles();
  const [fecha, setfecha] = useState("");

  function tiempoRestante(fecha) {
    const fechaObjeto = new Date(
      Date.parse(fecha) + new Date().getTimezoneOffset() * 60 * 1000,
    );
    const ahora = new Date();
    const diferencia = fechaObjeto - ahora;

    if (diferencia <= 24 * 60 * 60 * 1000) {
      const horas = Math.floor(
        (diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
      return horas + " horas, " + minutos + " minutos";
    } else {
      const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
      const horas = Math.floor(
        (diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
      return dias + " días, " + horas + " horas, " + minutos + " minutos";
    }
  }

  useEffect(() => {
    setfecha(tiempoRestante(usuario.fechaCaducaFirma));
    setInterval(() => {
      setfecha(tiempoRestante(usuario.fechaCaducaFirma));
    }, 60000); // eslint-disable-next-line
  }, []);
  const [graficas_estadisticas, setgraficas_estadisticas] = useState(null);
  useEffect(() => {
    const getgraficas_estadisticas = async () => {
      try {
        const res = await clienteAxios.post("/dashboard", {
          empCategoria: usuario.empCategoria,
        });

        setgraficas_estadisticas(res.data);
      } catch (error) {
        setgraficas_estadisticas(null);
      }
    };
    if (!graficas_estadisticas) {
      getgraficas_estadisticas();
    } // eslint-disable-next-line
  }, []);

  const [dataTotales, setdataTotales] = useState(null);

  if (!graficas_estadisticas) return <Cargando titulo="Cargando Data..." />;
  return (
    <div>
      {/* {
            hisclinicas: [
              { mes: "2023-09", total: 11 },
              { mes: "2023-07", total: 8 },
              { mes: "2023-06", total: 1 },
              { mes: "2023-04", total: 1431 },
            ],
            reservas: [
              { mes: "2023-09", total: 2 },
              { mes: "2023-08", total: 12 },
              { mes: "2023-07", total: 13 },
              { mes: "2023-06", total: 2 },
              { mes: "2023-04", total: 84 },
            ],
      } */}

      {dataTotales !== null && (
        <Dialog
          open={true}
          onClose={() => {
            setdataTotales(null);
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>{dataTotales.nombreCombustible} </DialogTitle>
          <DialogContent>
            <Box>
              <Typography variant="h6">Hoy</Typography>
              <Divider sx={{ marginBottom: "0.5rem" }} />
              {dataTotales.totalDiario.map((item, index) => (
                <Box key={index} display="flex" justifyContent="space-between">
                  <Typography variant="body2">
                    <strong>Total de Ventas: </strong> ${item.valor_total}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Volumen Total:</strong> {item.volumen_total}G
                  </Typography>
                </Box>
              ))}
            </Box>
            <Box sx={{ marginTop: "1rem" }}>
              <Typography variant="h6">Semanal</Typography>
              <Divider sx={{ marginBottom: "0.5rem" }} />
              {dataTotales.totalSemanal.map((item, index) => (
                <Box key={index} display="flex" justifyContent="space-between">
                  <Typography variant="body2">
                    <strong>Total de Ventas: </strong> ${item.valor_total}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Volumen Total:</strong> {item.volumen_total}G
                  </Typography>
                </Box>
              ))}
            </Box>
            <Box sx={{ marginTop: "1rem" }}>
              <Typography variant="h6">Mensual</Typography>
              <Divider sx={{ marginBottom: "0.5rem" }} />
              {dataTotales.totalMensual.map((item, index) => (
                <Box key={index} display="flex" justifyContent="space-between">
                  <Typography variant="body2">
                    <strong>Total de Ventas: </strong> ${item.valor_total}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Volumen Total:</strong> {item.volumen_total}G
                  </Typography>
                </Box>
              ))}
            </Box>
            <Box sx={{ marginTop: "1rem" }}>
              <Typography variant="h6">Anual</Typography>
              <Divider sx={{ marginBottom: "0.5rem" }} />
              {dataTotales.totalAnual.map((item, index) => (
                <Box key={index} display="flex" justifyContent="space-between">
                  <Typography variant="body2">
                    <strong>Total de Ventas: </strong> ${item.valor_total}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Volumen Total:</strong> {item.volumen_total}G
                  </Typography>
                </Box>
              ))}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setdataTotales(null);
              }}
              color="primary"
            >
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <Grid container spacing={3}>
        <Grid item xs={12} className={classes.paper}>
          <PanelCard>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 2,
                width: "100%",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  component="img"
                  src={usuario.logo}
                  alt="Logo Empresa"
                  sx={{
                    maxWidth: { xs: "60px", sm: "70px", md: "80px" },
                    borderRadius: 2,
                    objectFit: "contain",
                  }}
                />
                <Box>
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: 700, lineHeight: 1.1 }}
                  >
                    Hola, {usuario?.nombre || ""} 👋
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Resumen general de tu estación.
                  </Typography>
                </Box>
              </Box>

              {Number(fecha.split(" ")[0]) <= 50 &&
              (fecha.split(" ")[1] !== "Dia" ||
                fecha.split(" ")[1] !== "Dias") ? (
                <Tooltip
                  title={new Date(
                    Date.parse(usuario.fechaCaducaFirma) -
                      new Date().getTimezoneOffset() * 60 * 1000,
                  ).toLocaleString("es-ES", {
                    weekday: "short",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                  })}
                >
                  <Chip
                    icon={<WarningIcon />}
                    color="warning"
                    variant="outlined"
                    label={`Firma vence en: ${fecha}`}
                    sx={{ fontWeight: 600 }}
                  />
                </Tooltip>
              ) : null}
            </Box>

            <Divider sx={{ marginY: "1rem" }} />

            <Tabs
              value={info ? 0 : cardsSeccion ? 1 : estadisticas ? 2 : 0}
              onChange={(_, v) =>
                setseccionActive(
                  v === 0
                    ? { info: true }
                    : v === 1
                      ? { cardsSeccion: true }
                      : { estadisticas: true },
                )
              }
              sx={{ minHeight: 40 }}
            >
              <Tab
                icon={<DashboardIcon />}
                iconPosition="start"
                label="Datos Generales"
                sx={{ minHeight: 40, textTransform: "none", fontWeight: 600 }}
              />
              <Tab
                icon={<AppsIcon />}
                iconPosition="start"
                label="Categorías"
                sx={{ minHeight: 40, textTransform: "none", fontWeight: 600 }}
              />
              <Tab
                icon={<BarChartIcon />}
                iconPosition="start"
                label="Estadísticas"
                sx={{ minHeight: 40, textTransform: "none", fontWeight: 600 }}
              />
            </Tabs>
          </PanelCard>
          {cardsSeccion ? <GridCard /> : null}
        </Grid>{" "}
        {info ? (
          <>
            {usuario.empCategoria === "GASOLINERA" ? (
              <Grid item xs={12}>
                <SectionTitle
                  icono={<GasIcon sx={{ verticalAlign: "middle", mr: 0.5 }} />}
                  titulo="Dispensadores en tiempo real"
                  subtitulo="Estado de mangueras y despachos en vivo"
                />
                <DispensadoresScreen />
              </Grid>
            ) : null}
            {usuario.empCategoria === "GASOLINERA" ? null : (
              <Grid item xs={12} md={6}>
                {vet ? null : (
                  <PanelCard>
                    <Chart
                      titulo={"Transacciones"}
                      className={classes.paper}
                      dataGrafico={graficas_estadisticas}
                    />
                  </PanelCard>
                )}
              </Grid>
            )}
          </>
        ) : null}
        {estadisticas ? (
          <Grid item xs={12}>
            <SectionTitle
              icono={
                <DashboardIcon sx={{ verticalAlign: "middle", mr: 0.5 }} />
              }
              titulo="Estadísticas"
              subtitulo="Resumen de actividad reciente"
            />
            <Stack spacing={2}>
              {vet && (
                <PanelCard>
                  <GraficoLineaReserva
                    titulo={"Reservas"}
                    className={classes.paper}
                    dataGrafico={graficas_estadisticas}
                  />
                </PanelCard>
              )}
              {vet && (
                <PanelCard>
                  <GraficoLineaHis
                    titulo={"Historias Clinicas"}
                    className={classes.paper}
                    dataGrafico={graficas_estadisticas}
                  />
                </PanelCard>
              )}
              <PanelCard>
                <GraficoDougProductos
                  titulo={"Productos Más Vendidos"}
                  className={classes.paper}
                  dataGrafico={graficas_estadisticas}
                />
              </PanelCard>
            </Stack>
          </Grid>
        ) : null}
        {usuario.empCategoria === "GASOLINERA" ? (
          <Grid item xs={12}>
            <SectionTitle
              icono={<GasIcon sx={{ verticalAlign: "middle", mr: 0.5 }} />}
              titulo="Inventario de Tanques"
              subtitulo="Monitoreo en tiempo real del nivel de combustible"
            />
            <Grid container spacing={2}>
              {tanquesData.map((tanque, index) => (
                <Liquid
                  tanque={tanque}
                  key={index}
                  setdataTotales={setdataTotales}
                />
              ))}
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    </div>
  );
};

export default Dashboard;
